import React from 'react'

import { Modal } from 'antd'

import CustomInput from '../../CustomInput/customInput'

export const Preview = ({ preview, setPreview, field, errors, setCaptionValue }) => {
  const fileType = preview?.fileType || ''
  const isImage = (fileType.match(/.*image.*/) || []).length > 0
  const isPDF = (fileType.match(/.*pdf.*/) || []).length > 0

  return (
    <Modal
      className="customUploadModal"
      visible={!!preview}
      onCancel={() => setPreview(null)}
      onOk={() => setPreview(null)}
    >
      {isImage && (
        <a className="customUploadModal__image" href={preview.fileUri} target="_blank" rel="noopener noreferrer">
          {preview && <img alt={field} src={preview.fileUri} />}
        </a>
      )}
      {isPDF && (
        <a className="customUploadModal__pdf" href={preview.fileUri} target="_blank" rel="noopener noreferrer">
          Acesse o PDF
        </a>
      )}
      <div className="customUploadModal__notes">
        <CustomInput
          textArea
          type="textarea"
          field={`${field} (Notas)`}
          name={`caption_${preview?.id}`}
          errors={errors}
          setFieldValue={setCaptionValue}
          value={{ [`caption_${preview?.id}`]: preview?.caption }}
        />
      </div>
    </Modal>
  )
}
